<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
      Apply Promocode
  </h4>
</div>

<div class="modal-body">

  <div class="row">
      <div class="col-md-12">
          <div class="form-group">
              <input autocomplete="off" type="text" [(ngModel)]="promoCode" class="form-control" placeholder="Promocode">
              <a class="apply_button" (click)="applyCode()">Apply</a>
          </div>
      </div>
  </div>
  <div class="row">
    <div class="col-md-12" *ngFor="let data of allPromoCodes">
      <a class="promoname">{{data?.promotion_name}}
        <span class="apply_button" (click)="applyPromoCode(data?.promotion_name)">Apply</span>
      </a><br>
      <a class="description"><b>{{data?.description}}</b></a><br>
      <a class="description">{{data?.detail_description}}</a><br>
      <hr class="w-100">
    </div>
  </div>

</div>
<div class="modal-footer">
  <div class="col-md-12 modal-footer-button text-right">
      <button (click)="_bsModalRef.hide()" type="button" class="btn btn-default mr-3">Cancel</button>
  </div>
</div>